module.exports = __webpack_public_path__ + "img/2.6d16e7f8.jpg";